import React, { useEffect, useState } from "react";
import { useTable, useSortBy, useFilters, useGlobalFilter, useExpanded } from "react-table";
import {
  ChakraProvider, Table, Thead, Tbody, Tr, Th, Td, chakra, Link, Collapse,
  Flex, Spacer, Heading, Switch, Text, Box, IconButton, Fade, useDisclosure, ButtonGroup,
} from "@chakra-ui/react";
import { AddIcon, EditIcon, TriangleDownIcon, TriangleUpIcon,
  ChevronRightIcon, ChevronDownIcon, CopyIcon } from '@chakra-ui/icons'
import SignupForm from './CommonForm'
import SearchPrice from './SearchPrice'
import TableHistory from './TableHistory'


// This is a custom filter UI for selecting
// a unique option from a list
function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id}
}) {
  // Calculate the options for filtering
  // using the preFilteredRows
  const options = React.useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      /*if (id === 'pzy') {
        row.subRows.map((value, index) => {
          return options.add(value.values.pzy)
        })
      }*/
      if (id === 'name' && row.values['name'].includes(' ')) {
        options.add(row.values[id].substring(0, row.values[id].indexOf(' ')));
      } else {
        options.add(row.values[id]);
      }
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  // Render a multi-select box
  return (
    <select
      value={filterValue}
      onChange={(e, row) => {
        setFilter(e.target.value || undefined);
      }}
    >
      <option value="">Все</option>
      {options.map((option, i) => (
        <option key={i} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
}

function CustomTable({ columns, data }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    allColumns,
  } = useTable(
    {
      columns,
      data,
      getSubRows: (row) => row.subRows,
      initialState: {
        sortBy: [
          {
            id: 'dop_zas_pos_2',
            desc: true
          }
        ],
        // filters: [{ id: "pr_rekl_pos", value: [11, 900000] }],

        hiddenColumns: ["id", "pzy", "interes_pos", "bonus_pos", "nalog_bank_pos", "zak_zas_pos", "zasor_pos",
            "dop_zas_pos", "raznica_pos", "dohod_pos", "stavka_mlz_pos", "r_vip_doh_pos_2", "stavka_mlz_pos2",
            "vip_doh_pos_2", "interes_pok", "bonus_pok", "raznica_pok", "dohod_pok", "stavka_mlz_pok",
            "r_vip_doh_pok_2", "stavka_mlz_pok2", "vip_doh_pok_2"]
      }
    },
    useFilters, // useFilters!
    useGlobalFilter, // useGlobalFilter!
    useSortBy,
    useExpanded,
    (hooks) => {
      hooks.allColumns.push((columns) => [
        ...columns,
      ]);
    }
  );

  /* const showZero = () => {
    if (allColumns.find((item) => item.id === "pr_rekl_pos").filterValue[0] < 10) {
      setFilter("pr_rekl_pos", [11, 900000]);
    }
    else if (allColumns.find((item) => item.id === "pr_rekl_pos").filterValue[1] > 11) {
      setFilter("pr_rekl_pos", [0, 900000]);
    }
  }; */

  function showRekPart() {
    allColumns.find((item) => item.id === "pzy").toggleHidden();
    allColumns.find((item) => item.id === "interes_pos").toggleHidden();
    allColumns.find((item) => item.id === "bonus_pos").toggleHidden();
    allColumns.find((item) => item.id === "dohod_pos").toggleHidden();
    allColumns.find((item) => item.id === "vip_doh_pos_2").toggleHidden();
    allColumns.find((item) => item.id === "interes_pok").toggleHidden();
    allColumns.find((item) => item.id === "bonus_pok").toggleHidden();
    allColumns.find((item) => item.id === "dohod_pok").toggleHidden();
    allColumns.find((item) => item.id === "vip_doh_pok_2").toggleHidden();

    allColumns.find((item) => item.id === "rekom_vip_pos").toggleHidden();
    allColumns.find((item) => item.id === "rekom_vip_pok").toggleHidden();
  };

  function showRekVip() {
    allColumns.find((item) => item.id === "pzy").toggleHidden();
    allColumns.find((item) => item.id === "interes_pos").toggleHidden();
    allColumns.find((item) => item.id === "bonus_pos").toggleHidden();
    allColumns.find((item) => item.id === "nalog_bank_pos").toggleHidden();
    allColumns.find((item) => item.id === "zak_zas_pos").toggleHidden();
    allColumns.find((item) => item.id === "zasor_pos").toggleHidden();
    allColumns.find((item) => item.id === "dop_zas_pos").toggleHidden();
    allColumns.find((item) => item.id === "raznica_pos").toggleHidden();
    allColumns.find((item) => item.id === "dohod_pos").toggleHidden();
    allColumns.find((item) => item.id === "stavka_mlz_pos").toggleHidden();
    allColumns.find((item) => item.id === "r_vip_doh_pos_2").toggleHidden();
    allColumns.find((item) => item.id === "stavka_mlz_pos2").toggleHidden();
    allColumns.find((item) => item.id === "vip_doh_pos_2").toggleHidden();
    allColumns.find((item) => item.id === "interes_pok").toggleHidden();
    allColumns.find((item) => item.id === "bonus_pok").toggleHidden();
    allColumns.find((item) => item.id === "raznica_pok").toggleHidden();
    allColumns.find((item) => item.id === "dohod_pok").toggleHidden();
    allColumns.find((item) => item.id === "stavka_mlz_pok").toggleHidden();
    allColumns.find((item) => item.id === "r_vip_doh_pok_2").toggleHidden();
    allColumns.find((item) => item.id === "stavka_mlz_pok2").toggleHidden();
    allColumns.find((item) => item.id === "vip_doh_pok_2").toggleHidden();
  };

  return (
    <>
      <Flex position='relative'>
        <Spacer />
        <Spacer />
        <Box p={2}>
          <Text>
            Основные Столбцы
          </Text>
          <Switch colorScheme='yellow' onChange={showRekPart} />
        </Box>
        <Box p={2}>
          <Text>
            Все Столбцы
          </Text>
          <Switch colorScheme='orange' onChange={showRekVip} />
        </Box>
        <Spacer />
      </Flex>
      <Table {...getTableProps()} width='50%'>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th key={column.id}
                  {...column.getHeaderProps([
                    column.getSortByToggleProps(),
                    {
                      style: column.style,
                    }
                  ])}
                  isNumeric={column.isNumeric}
                  sx={{bg: '#e8e2db', textAlign: 'center', border:'0.5px solid black', p:'7px'}}
                >
                  {column.render('Header')}
                  <chakra.span pl='1'>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <TriangleDownIcon aria-label='sorted descending' />
                      ) : (
                        <TriangleUpIcon aria-label='sorted ascending' />
                      )
                    ) : column.canSort ? (
                        <Text>⬍</Text>
                    ) : null}
                  </chakra.span>
                  {/* Render the columns filter UI */}
                  <div>{column.canFilter ? column.render("Filter") : null}</div>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {rows.map((row) => {
          prepareRow(row)
          return (
            <Tr {...row.getRowProps()}>
              {row.cells.map((cell) => (
                <Td {...cell.getCellProps()} isNumeric={cell.column.isNumeric}
                  sx={{padding: '4px', textAlign: 'center', border:'0.5px solid black', whiteSpace: 'normal'}}>
                  {cell.render('Cell')}
                </Td>
              ))}
            </Tr>
          )
        })}
        </Tbody>
      </Table>
    </>
  );
}

export default function App() {
  const [idrow, setRow] = useState([]);
  const [newone, setNewone] = useState([]);
  const forma = useDisclosure();

  const columns = React.useMemo(
    () => [
      {
        // Build our expander column
        Header: () => null, // No header, please
        id: "expander", // Make sure it has an ID
        Cell: ({ row }) =>
          // Use the row.canExpand and row.getExpandedToggleProps prop getter
          // to build the toggle for expanding a row
          row.canExpand ? (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? <ChevronDownIcon/> : <ChevronRightIcon/>}
            </span>
          ) : null
      },
      {
        Header: ({ getToggleAllRowsSelectedProps }) => (
          <div>
            <Link href="#forma">
              <IconButton
                size='sm'
                colorScheme='yellow'
                icon={<AddIcon />}
                onClick={() => {
                  forma.onOpen();
                  setNewone(true);
                }}
              />
            </Link>
          </div>
        ),
        accessor: "buttons",
        disableFilters: true,
        disableSortBy: true,
        Cell: (row) => (
          <Link href="#forma">
            <IconButton size='sm' colorScheme='red' icon={<EditIcon />}
              onClick={() => {
                forma.onOpen();
                setRow(row.row.original.id);
                setNewone(false);
              }}
            />
          </Link>
        )
      },
      {
        Header: 'ИНФО',
        columns: [
          {
            Header: 'Данные',
            columns: [
              {
                Header: 'ID',
                accessor: 'id',
                disableFilters: true,
              },
              {
                Header: 'Ко',
                accessor: 'name',
                disableSortBy: true,
                Filter: SelectColumnFilter,
                Cell: ({ row }) => {
                  if (row.original.stop_otgr === 1) {
                    return <div style={{ backgroundColor: "red" }}>
                      СТОП {row.original.name}
                    </div>;
                  } else {
                    return (
                      <div>{row.isExpanded || row.depth === 1 ? <div style={{ backgroundColor: "orange" }}>
                        {row.original.name} </div> : row.original.name}</div>
                    )
                  }
                },
              },
              {
                Header: 'Дата изм.',
                accessor: 'data',
                sortInverted: true,
                disableFilters: true,
              },
              {
                Header: 'ПЗУ',
                accessor: 'pzy',
                disableSortBy: true,
                Filter: SelectColumnFilter,
              },
              {
                Header: 'Вид лома',
                accessor: 'vid_loma',
                disableSortBy: true,
                Filter: SelectColumnFilter,
              },
            ],
            style: {backgroundColor: '#f58d3a', color: 'white'},
          },
        ],
        style: {backgroundColor: '#f58d3a', color: 'black'},
      },
      {
        Header: 'Транспорт поставщика',
        columns: [
          {
            Header: 'Основное',
            columns: [
              {
                Header: 'Цена ПСА',
                accessor: 'pr_rekl_pos',
                disableFilters: true,
                filter: 'between',
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Инт.',
                accessor: 'interes_pos',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Бон.',
                accessor: 'bonus_pos',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Цена итого',
                accessor: 'pr_contr_pos',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: '% банка',
                accessor: 'nalog_bank_pos',
                disableFilters: true,
              },
              {
                Header: '% Засор Закуп',
                accessor: 'zak_zas_pos',
                disableFilters: true,
              },
              {
                Header: '% Засор Реал.',
                accessor: 'zasor_pos',
                disableFilters: true,
              },
              {
                Header: '% Доп засор',
                accessor: 'dop_zas_pos',
                disableFilters: true,
              },
              {
                Header: 'Факт цены',
                accessor: 'dop_zas_pos_2',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Разн.',
                accessor: 'raznica_pos',
                disableFilters: true,
                sortInverted: true,
                sortType: 'basic',
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
            ],
            style: {backgroundColor: '#fab95b', color: 'white'},
          },
          {
            Header: 'МЗЛ',
            columns: [
              {
                Header: 'Цена',
                accessor: 'dohod_pos_mzl',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Доход',
                accessor: 'dohod_pos',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
            ],
            style: {backgroundColor: '#fab95b', color: 'white'},
          },
          {
            Header: 'VIP Рек.',
            columns: [
              {
                Header: 'Цена',
                accessor: 'rekom_vip_pos',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Ставка',
                accessor: 'stavka_mlz_pos',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Доход',
                accessor: 'r_vip_doh_pos_2',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
            ],
            style: {backgroundColor: '#fab95b', color: 'white'},
          },
          {
            Header: 'VIP Устан.',
            columns: [
              {
                Header: 'Цена',
                accessor: 'pr_vip_pos',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Ставка',
                accessor: 'stavka_mlz_pos2',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Доход',
                accessor: 'vip_doh_pos_2',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
            ],
            style: {backgroundColor: '#fab95b', color: 'white'},
          },
        ],
        style: {backgroundColor: '#fab95b', color: 'black'},
      },
      {
        Header: 'Транспорт покупателя',
        columns: [
          {
            Header: 'Основное',
            columns: [
              {
                Header: 'Цена ПСА',
                accessor: 'pr_rekl_pok',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Инт.',
                accessor: 'interes_pok',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Бон.',
                accessor: 'bonus_pok',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Цена итого',
                accessor: 'pr_contr_pok',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Факт цены',
                accessor: 'dop_zas_pok_2',
                sortInverted: true,
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Разн.',
                accessor: 'raznica_pok',
                disableFilters: true,
                sortInverted: true,
                sortType: 'basic',
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
            ],
            style: {backgroundColor: '#f06119', color: 'white'},
          },
          {
            Header: 'МЗЛ',
            columns: [
              {
                Header: 'Цена',
                sortInverted: true,
                accessor: 'dohod_pok_mzl',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Доход',
                accessor: 'dohod_pok',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
            ],
            style: {backgroundColor: '#f06119', color: 'white'},
          },
          {
            Header: 'VIP Рек.',
            columns: [
              {
                Header: 'Цена',
                accessor: 'rekom_vip_pok',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Ставка',
                accessor: 'stavka_mlz_pok',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Доход',
                accessor: 'r_vip_doh_pok_2',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
            ],
            style: {backgroundColor: '#f06119', color: 'white'},
          },
          {
            Header: 'VIP Устан.',
            columns: [
              {
                Header: 'Цена',
                accessor: 'pr_vip_pok',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Ставка',
                accessor: 'stavka_mlz_pok2',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
              {
                Header: 'Доход',
                accessor: 'vip_doh_pok_2',
                disableFilters: true,
                Cell: row => <div>{row.value ? row.value.toLocaleString('de-CH') : 0}</div>
              },
            ],
            style: {backgroundColor: '#f06119', color: 'white'},
          },
        ],
        style: {backgroundColor: '#f06119', color: 'black'},
      },
      {
        accessor: "history",
        disableFilters: true,
        disableSortBy: true,
        Cell: (row) => (
           <ButtonGroup variant='outline' spacing='2'>
             <Link href="#forma">
               <IconButton size='xs' colorScheme='black' icon={<CopyIcon />}
                 onClick={() => {
                   forma.onOpen();
                   setRow(row.row.original.id);
                   setNewone(true);
                 }}
               />
             </Link>
             <TableHistory idstr={row.row.original.id}/>
           </ButtonGroup>
        )
      },
    ],
    [forma],
  )

  const current = new Date();
  const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;

  const [data, setData] = useState([]); // use an empty array as initial value
  const [oldInfo] = useState([]);
  const handleChange = values => {
     const new_val = values.reduce(function (acc, obj) {
      if (obj.commer === "Ком") {
        obj.name = obj.name + " К"
      }
      const x = acc.findIndex((entity) => entity.name===obj.name &&
        entity.commer===obj.commer && entity.vid_loma===obj.vid_loma &&
        entity.zasor_pos===obj.zasor_pos && entity.zak_zas_pos===obj.zak_zas_pos && entity.stop_otgr===obj.stop_otgr &&
        entity.pr_vip_pos===obj.pr_vip_pos && entity.dohod_pos_mzl===obj.dohod_pos_mzl &&
        entity.pr_vip_pok===obj.pr_vip_pok && entity.dohod_pok_mzl===obj.dohod_pok_mzl &&
        entity.zak_zas===obj.zak_zas);
      if (x !== -1) {
        acc[x].subRows.push(obj)
      } else {
        const xx={'id':obj.id, 'name':obj.name, 'commer':obj.commer, 'data':obj.data,
          'pr_contr_pos':obj.pr_contr_pos, 'pzy':obj.pzy, 'vid_loma':obj.vid_loma, 'zasor_pos':obj.zasor_pos,
          'zak_zas_pos':obj.zak_zas_pos, 'stop_otgr':obj.stop_otgr, 'pr_vip_pos':obj.pr_vip_pos,
          'dohod_pos_mzl':obj.dohod_pos_mzl, 'pr_vip_pok':obj.pr_vip_pok, 'dohod_pok_mzl':obj.dohod_pok_mzl,
          'zak_zas':obj.zak_zas, 'pr_rekl_pos':obj.pr_rekl_pos, 'interes_pos':obj.interes_pos,
          'bonus_pos':obj.bonus_pos, 'nalog_bank_pos':obj.nalog_bank_pos, 'dop_zas_pos':obj.dop_zas_pos,
          'dop_zas_pos_2':obj.dop_zas_pos_2, 'raznica_pos':obj.raznica_pos, 'dohod_pos':obj.dohod_pos,
          'rekom_vip_pos':obj.rekom_vip_pos, 'stavka_mlz_pos':obj.stavka_mlz_pos, 'r_vip_doh_pos_2':obj.r_vip_doh_pos_2,
          'stavka_mlz_pos2':obj.stavka_mlz_pos2, 'vip_doh_pos_2':obj.vip_doh_pos_2, 'pr_rekl_pok':obj.pr_rekl_pok,
          'interes_pok':obj.interes_pok, 'bonus_pok':obj.bonus_pok, 'pr_contr_pok':obj.pr_contr_pok,
          'dop_zas_pok_2':obj.dop_zas_pok_2, 'raznica_pok':obj.raznica_pok, 'dohod_pok':obj.dohod_pok,
          'rekom_vip_pok':obj.rekom_vip_pok, 'stavka_mlz_pok':obj.stavka_mlz_pok, 'r_vip_doh_pok_2':obj.r_vip_doh_pok_2,
          'vip_doh_pok_2':obj.vip_doh_pok_2, 'stavka_mlz_pok2':obj.stavka_mlz_pok2, subRows:[]}
        acc.push(xx)
      }
      return acc;
    }, [])
     setData(new_val);
  }

  const older = useDisclosure();

  const fetchPrice = async () => {
    const response = await fetch("/api/boss/p4jfqejd5kw")  // fetch - выполнить запрос
    const price = await response.json()  // извлечь полученные данные в виде JSON,
    const result = price.data.reduce(function (acc, obj) {
      if (obj.commer === "Ком") {
        obj.name = obj.name + " К"
      }
      const x = acc.findIndex((entity) => entity.name===obj.name &&
        entity.commer===obj.commer && entity.vid_loma===obj.vid_loma &&
        entity.zasor_pos===obj.zasor_pos && entity.zak_zas_pos===obj.zak_zas_pos && entity.stop_otgr===obj.stop_otgr &&
        entity.pr_vip_pos===obj.pr_vip_pos && entity.dohod_pos_mzl===obj.dohod_pos_mzl &&
        entity.pr_vip_pok===obj.pr_vip_pok && entity.dohod_pok_mzl===obj.dohod_pok_mzl &&
        entity.zak_zas===obj.zak_zas);
      if (x !== -1) {
        acc[x].subRows.push(obj)
      } else {
        const xx={'id':obj.id, 'name':obj.name, 'commer':obj.commer, 'data':obj.data,
          'pr_contr_pos':obj.pr_contr_pos, 'pzy':obj.pzy, 'vid_loma':obj.vid_loma, 'zasor_pos':obj.zasor_pos,
          'zak_zas_pos':obj.zak_zas_pos, 'stop_otgr':obj.stop_otgr, 'pr_vip_pos':obj.pr_vip_pos,
          'dohod_pos_mzl':obj.dohod_pos_mzl, 'pr_vip_pok':obj.pr_vip_pok, 'dohod_pok_mzl':obj.dohod_pok_mzl,
          'zak_zas':obj.zak_zas, 'pr_rekl_pos':obj.pr_rekl_pos, 'interes_pos':obj.interes_pos,
          'bonus_pos':obj.bonus_pos, 'nalog_bank_pos':obj.nalog_bank_pos, 'dop_zas_pos':obj.dop_zas_pos,
          'dop_zas_pos_2':obj.dop_zas_pos_2, 'raznica_pos':obj.raznica_pos, 'dohod_pos':obj.dohod_pos,
          'rekom_vip_pos':obj.rekom_vip_pos, 'stavka_mlz_pos':obj.stavka_mlz_pos, 'r_vip_doh_pos_2':obj.r_vip_doh_pos_2,
          'stavka_mlz_pos2':obj.stavka_mlz_pos2, 'vip_doh_pos_2':obj.vip_doh_pos_2, 'pr_rekl_pok':obj.pr_rekl_pok,
          'interes_pok':obj.interes_pok, 'bonus_pok':obj.bonus_pok, 'pr_contr_pok':obj.pr_contr_pok,
          'dop_zas_pok_2':obj.dop_zas_pok_2, 'raznica_pok':obj.raznica_pok, 'dohod_pok':obj.dohod_pok,
          'rekom_vip_pok':obj.rekom_vip_pok, 'stavka_mlz_pok':obj.stavka_mlz_pok, 'r_vip_doh_pok_2':obj.r_vip_doh_pok_2,
          'vip_doh_pok_2':obj.vip_doh_pok_2, 'stavka_mlz_pok2':obj.stavka_mlz_pok2, subRows:[]}
        acc.push(xx)
      }
      return acc;
    }, [])
    setData(result)
  }
  useEffect(() => {
    fetchPrice();
  }, [])

  return (
    <ChakraProvider>
      <Flex>
        <Spacer />
        <Heading p='2' as='h4' size='md' id="start">
          Дата: {date}
        </Heading>
        <Spacer />
        <SearchPrice handleChange={handleChange} user={'admin'} />
      </Flex>
      <Collapse in={older.isOpen} animateOpacity sx={{overflow: 'scroll'}}>
        <CustomTable
          columns={columns}
          data={oldInfo}
        />
      </Collapse>
      <CustomTable columns={columns} data={data} />
      <Fade id="form" in={forma.isOpen}>
        <Box
          p='10px'
          color='black'
          mt='1'
          bg='white'
          rounded='md'
          id="forma"
          width='1100px'
        >
          <SignupForm
            idstr={idrow}
            newone={newone}
            forma={forma}
          />
        </Box>
      </Fade>
    </ChakraProvider>
  );
}